'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { getTrackRecommendationsUrl } from '../../../utils/RoutingUtils';
import BasicInterstitial from '../BasicInterstitial';

const TrackIncompleteInterstitial = ({
  toRecommendations,
  trackId
}) => {
  return /*#__PURE__*/_jsx(BasicInterstitial, {
    buttonI18n: `learningCenter.tracks.interstitials.${toRecommendations ? 'next' : 'backToTracks'}`,
    buttonLink: toRecommendations ? getTrackRecommendationsUrl(trackId) : '/',
    buttonUse: toRecommendations ? 'secondary' : 'primary',
    headingI18n: "learningCenter.tracks.interstitials.trackIncomplete",
    illustrationName: "errors/hourglass",
    subheadingI18n: "learningCenter.tracks.interstitials.trackIncompleteSubheading",
    use: "info"
  });
};

TrackIncompleteInterstitial.propTypes = {
  toRecommendations: PropTypes.bool,
  trackId: (props, propName, componentName) => props.toRecommendations && !['number', 'string'].includes(typeof props[propName]) && new Error(`${propName} prop in ${componentName} must be set when toRecommendations is set to \`true\``)
};
export default TrackIncompleteInterstitial;